(() => {
  const configNode = document.querySelector('[data-brume-purchase-config]');
  if (!configNode || configNode.dataset.initialized) return;
  configNode.dataset.initialized = 'true';
  const config = JSON.parse(configNode.textContent);
  const section = document.querySelector(`[data-section-id="${config.sectionId}"][data-brume-bundle]`);
  if (!section) return;
  const locale = document.documentElement.lang || 'fr';
  const money = new Intl.NumberFormat(locale, { style: 'currency', currency: config.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
  let scheduled = false;

  function update() {
    scheduled = false;
    const selected = section.querySelector('#pumper_bundle_svelte .pumper_pair:checked');
    const tier = selected?.closest('.pumper_block__cb');
    const priceText = tier?.querySelector('.tier-price__main')?.textContent.trim();
    const count = tier?.querySelectorAll('.pumper_block__cbinfo--slot').length;
    if (!selected || !count || !priceText) return;
    const numeric = priceText.replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
    const price = Number(numeric);
    if (!Number.isFinite(price) || price <= 0) return;
    const main = section.querySelector('.product-form__submit');
    if (!main) return;
    const sticky = section.querySelector('sticky-buy-button');
    const stickyButton = sticky?.querySelector('button');
    const busy = main.disabled || main.getAttribute('aria-disabled') === 'true' || main.getAttribute('aria-busy') === 'true' || main.classList.contains('loading');
    if (stickyButton) stickyButton.disabled = busy;
    if (busy) return;
    const label = (count === 1 ? config.addOne : config.addMany)
      .replace('__COUNT__', String(count)).replace('__PRICE__', money.format(price));
    const styledText = main.querySelector('section-store--atc-main-text');
    if (styledText) {
      styledText.style.setProperty('white-space', 'normal', 'important');
      styledText.style.setProperty('min-width', '0', 'important');
    }
    const themeText = main.querySelector('.section-store--atc-original > span') || main.querySelector(':scope > span:not([aria-hidden="true"])');
    for (const node of [styledText, themeText]) {
      if (node && node.textContent.trim() !== label) node.textContent = label;
    }
    if (main.getAttribute('aria-label') !== label) main.setAttribute('aria-label', label);
    const stickyLabel = (count === 1 ? config.chooseOne : config.chooseMany)
      .replace('__COUNT__', String(count)).replace('__PRICE__', money.format(price));
    const stickyText = stickyButton?.querySelector('span');
    if (stickyText && stickyText.textContent.trim() !== stickyLabel) stickyText.textContent = stickyLabel;
    if (stickyButton && stickyButton.getAttribute('aria-label') !== stickyLabel) stickyButton.setAttribute('aria-label', stickyLabel);
    if (sticky && !sticky.dataset.brumeSticky) {
      sticky.dataset.brumeSticky = 'true';
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  section.addEventListener('change', schedule);
  section.addEventListener('input', schedule);
  new MutationObserver(schedule).observe(section, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'checked', 'value']
  });
  schedule();
})();
